(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ode-about-doing-good"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", e => {
    init_giving_back_swiper();
  });

  function init_giving_back_swiper(){
    let _giving_el = document.querySelector(".swiper-giving-back");
    let _giving_swiper = new Swiper(_giving_el, {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 1000,   
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      on: {
        "init afterInit slideChange": function(){
					let event = document.createEvent("Event");
					event.initEvent("swiper-build", true, true);
					document.dispatchEvent(event);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-about-top"]) return;
  try {
    
	document.addEventListener("DOMContentLoaded", e => {
		gsap.registerPlugin(ScrollTrigger);

		init_top_story_animation();
	});

	function init_top_story_animation(){
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".top-story",
				start: 'top top',
				end: 'bottom 100%',
				scrub: 0,
				pin:".inner-wrapper"
			},
			duration: 20
		})
		tl.to(".top-story .visual-2", { ease: "sine", alpha: 0, y: "100px", duration: 0 }, 0);
		tl.to(".top-story .content-2", { ease: "sine", alpha: 0, y: "100px", duration: 0 }, 0);
		tl.to(".top-story .content-3", { ease: "sine", alpha: 0, y: "100px", duration: 0 }, 0);
		tl.to(".top-story .content-4", { ease: "sine", alpha: 0, y: "100px", duration: 0 }, 0);

		tl.to(".top-story .visual-1", { ease: "sine", alpha: 1, duration: 0 }, 0);
		tl.to(".top-story .content-1", { ease: "sine", alpha: 1, duration: 0 }, 0);
		tl.to(".top-story .visual-1", { ease: "sine", alpha: 0, duration: 2 }, 1);
		tl.to(".top-story .content-1", { ease: "sine", alpha: 0, y:"-100px", duration: 2 }, 1);
		
		tl.to(".top-story .content-2", { ease: "sine", alpha: 1, y:"0px", duration: 2 }, 2);
		tl.to(".top-story .content-2", { ease: "sine", alpha: 0, y:"-100px", duration: 2 }, 5);
		
		tl.to(".top-story .content-3", { ease: "sine", alpha: 1, y:"0px", duration: 2 }, 6);
		tl.to(".top-story .content-3", { ease: "sine", alpha: 0, y:"-100px", duration: 2 }, 10);

		tl.to(".top-story .content-4", { ease: "sine", alpha: 1, y: "0px", duration: 2 }, 10);
		tl.to(".top-story .content-4", { ease: "sine", alpha: 0, y: "-50px", duration: 2 }, 14);
		tl.to(".top-story .visual-2", { ease: "sine", alpha: 1, y: "0px", duration: 2 }, 10);
		tl.to(".top-story .visual-2", { ease: "sine", alpha: 0, duration: 2 }, 14);

		tl.to(".top-story .content-5", { ease: "sine", alpha: 1, y: "0px", duration: 2 }, 15);
		// tl.to(".top-story .content-4", { ease: "sine", color: "#000000", duration: 2 }, 17);
		// tl.to(".top-story .content-4", { ease: "sine", alpha: 0, y: "-100px", duration: 2 }, 20);

		tl.to(".top-story .visual-3", { ease: "sine", alpha: 1, duration: 3 }, 13);
		tl.to(".top-story .visual-4", { ease: "sine", alpha: 1, duration: 5 }, 17);
	}
		

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-apps-instagram"] && !Shopify.designMode) return;
  try {
    

	document.addEventListener('DOMContentLoaded', (e)=>{
  let _insta_el = document.querySelector('.swiper-insta');
    let _insta_swiper = new Swiper(_insta_el, {
      slidesPerView: 2,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: 'row',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        1480: {
          slidesPerView: 5,
          spaceBetween: 50,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-customer-reviews"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', (e)=>{
    let _list = document.querySelector(".reviews-list");
    let _review_el = document.querySelector(".swiper-reviews");
    let _review_swiper = new Swiper(_review_el, {
      slidesPerView: 1.3,
      centeredSlides : true,  
      spaceBetween: 20,
      speed: 800,
      loop: true,
      loopedSlides: 1,
      loopFillGroupWithBlank: false,
      navigation: {
				nextEl: _list.querySelector(".swiper-button-next"),
				prevEl: _list.querySelector(".swiper-button-prev"),
			},
      breakpoints: {
        880: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            centeredSlides : true,
            loop: true
        },
        1000: {
            slidesPerView: 5,
            spaceBetween: 30,
            centeredSlides : false,
            loop: false
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-giving-back-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", e => {
    init_giving_back_swiper();
  });

  function init_giving_back_swiper(){
    let _giving_el = document.querySelector(".swiper-giving-back");
    let _giving_swiper = new Swiper(_giving_el, {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 1000,   
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      on: {
        "init afterInit slideChange": function(){
					let event = document.createEvent("Event");
					event.initEvent("swiper-build", true, true);
					document.dispatchEvent(event);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-giving-back-special"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", e => {
    init_giving_back_swiper_special();
  });

  function init_giving_back_swiper_special(){
    let _giving_el = document.querySelector(".swiper-giving-back-special");
    let _giving_btn = document.getElementById("giving-back-btn-target");
    let _giving_swiper = new Swiper(_giving_el, {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 1000,   
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      // on: {
      //   "slideChange": function(){
      //     _giving_btn.href = _giving_swiper.slides[_giving_swiper.realIndex].dataset.url
      //   }
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-home-giving-back"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', (e)=>{
    let _arg_el = document.querySelector(".swiper-arguments");
    let _arg_swiper = new Swiper(_arg_el, {
      slidesPerView: 1.2,
      centeredSlides : true,  
      spaceBetween: 0,
      speed: 800,
      loop: true,
      loopedSlides: 1,
      loopFillGroupWithBlank: false, 
      autoplay: {
        delay: 2500,
        disableOnInteraction: true
      },
      breakpoints: {
        880: {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides : false,
          loopedSlides: 3,
          loop: true,
        }
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-home-testimonies"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var _el = document.querySelector('.swiper-home-testimonies');
    if (!_el) return;
    new Swiper(_el.querySelector('.swiper'), {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: _el.querySelector('.swiper-button-next'),
        prevEl: _el.querySelector('.swiper-button-prev')
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-image-banner-carousel"] && !Shopify.designMode) return;
  try {
    
    let _swiper_banner_carousel = document.querySelectorAll(".swiper-banner-carousel");

    if(_swiper_banner_carousel){
        _swiper_banner_carousel.forEach(elt => {
            let _swiper = new Swiper(elt, {
                slidesPerView: 1,
                loop: true,
                speed: 800,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: true
                },
                navigation: {
                	nextEl: elt.querySelector(".swiper-button-next"),
                	prevEl: elt.querySelector(".swiper-button-prev"),
                },
                pagination: {
                    el: elt.querySelector(".swiper-pagination")
                },	
            });
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-instagram-product"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', (e)=>{
	let _insta_el = document.querySelector('.swiper-insta');
		let _insta_swiper = new Swiper(_insta_el, {
			slidesPerView: 2,
			spaceBetween: 5,
			grid: {
				rows: 3,
				fill: 'row',
			},
			breakpoints: {
				640: {
					slidesPerView: 3,
					grid: {
						rows: 2,
						fill: 'row',
					},
				},
				768: {
					slidesPerView: 3,
					grid: {
						rows: 2,
						fill: 'row',
					},
				},
				1024: {
					slidesPerView: 4,
					grid: {
						rows: 2,
						fill: 'row',
					},
				},
				1480: {
					slidesPerView: 5,
					grid: {
						rows: 2,
						fill: 'row',
					},
				},
			},
			on: {
				afterInit: function () {
					let event = document.createEvent("Event");
					event.initEvent("swiper-build", true, true);
					document.dispatchEvent(event);
				},
			},
			navigation: {
				nextEl: _insta_el.querySelector(".swiper-button-next"),
				prevEl: _insta_el.querySelector(".swiper-button-prev"),
			}
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-instagram"] && !Shopify.designMode) return;
  try {
    

	document.addEventListener('DOMContentLoaded', (e)=>{
  let _insta_el = document.querySelector('.swiper-insta');
    let _insta_swiper = new Swiper(_insta_el, {
      slidesPerView: 2,
      spaceBetween: 20,
			speed: 800,
      grid: {
        rows: 2,
        fill: 'row',
      },
      navigation: {
        nextEl: _insta_el.querySelector(".swiper-button-next"),
        prevEl: _insta_el.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
        1480: {
          slidesPerView: 5,
          spaceBetween: 50,
          grid: {
            rows: 1,
            fill: 'row',
          },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-moving-msg"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', function() {
        let _swiper_banner_carousel = document.querySelector(".swiper-msg-carousel");
        let _swiper_msg = new Swiper(_swiper_banner_carousel, {
            slidesPerView: 1,
            loop: true,
            speed: 800,
            autoplay: {
                delay: 6000,
                disableOnInteraction: true
            },
            navigation: {
                nextEl: _swiper_banner_carousel.querySelector(".swiper-button-next"),
                prevEl: _swiper_banner_carousel.querySelector(".swiper-button-prev"),
            },
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-product-boxset"]) return;
  try {
    

	// INTERSECTION OBSERVER 

	const item = document.querySelector('.product-visuals-wrapper');
	const actionHead = document.querySelector('.product-action-wrapper .action-head');
	const annoncement = document.querySelector('.ode-annoncement');

	function createTreshold(_num) {
		let _a = [];
		let _div = 1/_num;
		for(let i=0; i<=_num; i++){
			_a.push((_div * i).toFixed(3));
		}
		return _a;
	}

	let _threshold = createTreshold(200);

	const observer = new IntersectionObserver(function (entries) {
		// console.log(entries);
		entries.forEach(entry => {
			let visiblePct = Math.floor(entry.intersectionRatio * 100);
			// console.log(entry.boundingClientRect.bottom);
			// console.log(window.scrollY);

			if(entry.boundingClientRect.bottom < window.innerHeight - actionHead.offsetHeight){
				product_action_wrapper.classList.add("is-relative");
			} else {
				product_action_wrapper.classList.remove("is-relative");
			}

			
			// if(window.scrollY > 30 && entry.boundingClientRect.bottom > window.innerHeight - actionHead.offsetHeight){
			// 	product_action_wrapper.classList.add("hide-details");
			// 	if(annoncement) annoncement.classList.add("hide");
			// } else {
			// 	product_action_wrapper.classList.remove("hide-details");
			// 	if(annoncement) annoncement.classList.remove("hide");
			// }
		});
	}, {
		threshold: _threshold
	});

	const product_action_wrapper = document.querySelector('.product-action-wrapper');
	observer.observe(item);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-product"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', (e)=>{
		let _notes_el = document.querySelectorAll(".swiper-notes");

		if(_notes_el){
			_notes_el.forEach(elt => {
				let _swiper = new Swiper(elt, {
					slidesPerView: 1,
					loop: true,
					spaceBetween: 80,
					speed: 800,
					effect: "fade",
					fadeEffect: {
						crossFade: true,
					},
					navigation: {
						nextEl: elt.querySelector(".swiper-button-next"),
						prevEl: elt.querySelector(".swiper-button-prev"),
					},			
				});
			});
		}


		let _swiper_what = document.querySelectorAll(".swiper-what");

		if(_swiper_what){
			_swiper_what.forEach(elt => {
				let _swiper = new Swiper(elt, {
					slidesPerView: 1,
					loop: true,
					speed: 800,
					effect: "fade",
					fadeEffect: {
						crossFade: true,
					},
					// autoplay: {
					// 	delay: 6000,
					// 	disableOnInteraction: true
					// },
					// navigation: {
					// 	nextEl: elt.querySelector(".swiper-button-next"),
					// 	prevEl: elt.querySelector(".swiper-button-prev"),
					// },
					pagination: {
						el: elt.querySelector(".swiper-pagination"),
						clickable: true
					},	
				});
			});
		}

		let _swiper_ingredients_carousel = document.querySelectorAll(".swiper-ingredients-carousel");

		if(_swiper_ingredients_carousel){
			_swiper_ingredients_carousel.forEach(elt => {
				let _swiper = new Swiper(elt, {
					slidesPerView: 1,
					loop: true,
					speed: 800,
					effect: "fade",
					fadeEffect: {
						crossFade: true,
					},
					autoplay: {
						delay: 6000,
						disableOnInteraction: true
					},
					navigation: {
						nextEl: elt.querySelector(".swiper-button-next"),
						prevEl: elt.querySelector(".swiper-button-prev"),
					},
					pagination: {
						el: elt.querySelector(".swiper-pagination")
					},	
				});
			});
		}
	});



	// INTERSECTION OBSERVER 

	const item = document.querySelector('.product-visuals-wrapper');
	const actionHead = document.querySelector('.product-action-wrapper .action-head');
	const annoncement = document.querySelector('.ode-annoncement');

	function createTreshold(_num) {
		let _a = [];
		let _div = 1/_num;
		for(let i=0; i<=_num; i++){
			_a.push((_div * i).toFixed(3));
		}
		return _a;
	}

	let _threshold = createTreshold(200);

	const observer = new IntersectionObserver(function (entries) {
		// console.log(entries);
		entries.forEach(entry => {
			let visiblePct = Math.floor(entry.intersectionRatio * 100);
			// console.log(entry.boundingClientRect.bottom);
			// console.log(window.scrollY);

			if(entry.boundingClientRect.bottom < window.innerHeight - actionHead.offsetHeight){
				product_action_wrapper.classList.add("is-relative");
			} else {
				product_action_wrapper.classList.remove("is-relative");
			}

			
			// if(window.scrollY > 20 && entry.boundingClientRect.bottom > window.innerHeight - actionHead.offsetHeight){
			// 	product_action_wrapper.classList.add("hide-details");
			// 	if(annoncement) annoncement.classList.add("hide");
			// } else {
			// 	product_action_wrapper.classList.remove("hide-details");
			// 	if(annoncement) annoncement.classList.remove("hide");
			// }
		});
	}, {
		threshold: _threshold
	});

	const product_action_wrapper = document.querySelector('.product-action-wrapper');
	observer.observe(item);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ode-reassurance"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', (e) => {
		let _reassurance_el = document.querySelector(".swiper-reassurance");
		let _reassurance_swiper = new Swiper(_reassurance_el.querySelector(".swiper"), {
			slidesPerView: 2,
			spaceBetween: 10,
			forceLoop: true,
			autoplay: {
				delay: 2500
			},
			speed: 800,
			navigation: {
				nextEl: _reassurance_el.querySelector(".swiper-button-next"),
				prevEl: _reassurance_el.querySelector(".swiper-button-prev"),
			},
			on: {
				resize: function () {
					let event = document.createEvent("Event");
					event.initEvent("swiper-build", true, true);
					document.dispatchEvent(event);
				}
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
					loop: true,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
					loop: true,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 50,
					loop: true,
				},
			},
		});
	});

  } catch(e) { console.error(e); }
})();
})();
